import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import profileImg from '../assets/images/me.png';
import { useTranslation } from 'react-i18next';
const IMAGE_SIZE = 440;

const About = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language?.startsWith('ar');
  return (
    <Box id="about" sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: 10,
      width: '90%',
      minHeight: '80vh',
      
      // No background here for seamless look
    }}>
      <Card
        component={motion.div}
        whileHover={{ y: -6, boxShadow: '0 16px 48px rgba(233, 84, 32, 0.2)' }}
        transition={{ type: 'spring', stiffness: 320, damping: 22 }}
        elevation={8}
        sx={{
        maxWidth: '98vw',
        width: { xs: '98vw', sm: 800, md: 1000, lg: 1200, xl: 1800, '2xl': 2000 },
        p: 4,
        borderRadius: 5,
        background: '#fff',
        boxShadow: '0 0px 0px 0 rgba(31, 38, 135, 0.18)',
        color: '#23243a',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        bgcolor: "unset"
      }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box
            component="img"
            src={profileImg}
            alt="Abdulaziz Almuflehi"
            sx={{
              width: IMAGE_SIZE,
              maxWidth: '100%',
              height: 'auto',
              display: 'block',
              mb: 2,
              borderRadius: 2,
              objectFit: 'cover',
            }}
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 10,
              backgroundColor: 'unset',
              width: '100%',
              borderRadius: 5,
              padding: 20,
              textAlign: 'justify',
              direction: isAr ? 'rtl' : 'ltr',
            }}
          >
          <Typography variant="h4" fontWeight={700} align="center" sx={{ color: 'white', letterSpacing: 1, mt: 2 }}>
            {t('about.name')}
          </Typography>
          <Typography variant="subtitle1" align="center" sx={{ color: '#e95420', fontWeight: 600, mb: 1 }}>
            {t('about.role')}
          </Typography>
          <Typography variant="body1" align="center" sx={{ color: 'white', opacity: 0.92, fontSize: 18, textAlign: 'justify' }}>
          {t('about.bio')}
          </Typography>
          </div>
        </CardContent>
      </Card>
    </Box>
  );
};

export default About; 